import React from 'react';
import * as styles from './overview.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Overview = _ref => {
  var name = _ref.name,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    layout = _ref.layout;
  return ___EmotionJSX("div", {
    css: styles.overview
  }, ___EmotionJSX("div", {
    css: styles.name
  }, name), title && ___EmotionJSX("div", {
    css: styles.title
  }, title), layout === 'three-column' && ___EmotionJSX("div", {
    css: styles.separatorBar
  }));
};